import { useContext, useEffect, useState } from 'react'
import Button from '../../../common/Button'
import InlineCheckbox from '../../../common/InlineCheckbox'
import InputText from '../../../common/InputText'
import { postRequest } from '../../../../services/base'
import { NavContext } from '../../../../context/global_context'

const UserEditCreateForm = (props) => {
  const [state, dispatch] = useContext(NavContext)

  const [userDetails, setUserDetails] = useState({
    email: '',
    password: '',
    last_name: '',
    first_name: '',
    is_admin: false,
    is_active: true,
  })

  useEffect(() => {
    if (props?.userDetails?.email) {
      setUserDetails(props?.userDetails)
    }
  }, [props?.userDetails])

  const saveUserDetails = async (e) => {
    const form = e.target
    const formData = new FormData(form)
    formData.delete('is_admin')
    formData.append('is_admin', userDetails.is_admin)
    let res = await postRequest(`/api/users/save_user/`, formData)
    if (Object.keys(res?.errors).length > 0) {
      let msg = ''
      Object.keys(res?.errors).map((obj) => {
        if (msg) {
          msg += `, ${res.errors[obj]}`
        } else {
          msg = `${res.errors[obj]}`
        }
      })

      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: msg,
        },
      })
    } else if (res?.msg) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      props.onSave()
    }
  }

  const showHidePassword = () => {
    let x = document.getElementById('password')
    if (x.type === 'password') {
      x.type = 'text'
    } else {
      x.type = 'password'
    }
  }

  return (
    <div className="container">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveUserDetails(e)
        }}
      >
        <input type="hidden" value={!props.isEdit} name="is_create" />
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="first_name"
              type="text"
              label="First Name"
              value={userDetails.first_name}
            />
          </div>
          <div className="w-1/2">
            <InputText
              name="last_name"
              type="text"
              label="Last Name"
              value={userDetails.last_name}
              onChange={(value) => {
                setUserDetails({ ...userDetails, last_name: value })
              }}
              isRequired={false}
            />
          </div>
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InputText
              name="email"
              type="email"
              label="Email"
              value={userDetails.email}
              onChange={(value) => {
                setUserDetails({ ...userDetails, email: value })
              }}
            />
          </div>
          {!props?.isEdit && (
            <div className="flex w-1/2 items-end">
              <InputText
                name="password"
                type="password"
                label="Password"
                value={userDetails.password}
                onChange={(value) => {
                  setUserDetails({ ...userDetails, password: value })
                }}
              />
              <span
                className="p-2 underline cursor-pointer"
                onClick={() => {
                  showHidePassword()
                }}
              >
                show
              </span>
            </div>
          )}

          <input
            type="hidden"
            value={userDetails?.is_active}
            name="is_active"
          />
        </div>
        <div className="flex">
          <div className="w-1/2">
            <InlineCheckbox
              type="checkbox"
              onChange={(value) => {
                setUserDetails({
                  ...userDetails,
                  is_admin: value,
                })
              }}
              label="Is Admin"
              name="is_admin"
              value={userDetails.is_admin}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <div className="w-1/4">
            <Button
              type="submit"
              className={`cursor-pointer btn my-4 w-full justify-end`}
              onClick={(e) => {}}
              value={'text'}
              text={props.isEdit ? 'Save User' : 'Create New User'}
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default UserEditCreateForm
